// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_f3-3";
export var flatBottomCorners = "_f3-5";
export var productImage = "_f3-0";
export var quantityContainer = "_f3-2";
export var quantityHeader = "_f3-6";
export var tooltip = "_f3-1";
export var wrapAndEllipsesOverflow = "_f3-4";